import CKEditorField from "components/CkEditor/CkEditor";
import { CustomAsyncSelect } from "components/Common/Common";
import SaveRecommendationTemplatePop from "components/Modals/SaveRecommendationTemplate";
import { AppSelect2Field } from "components/shared/FormComponents/AppSelect2Field";
import CustomEditor from "components/TipTapEditor/CustomeEditor";
import { useFormikContext } from "formik";
import useModal from "hooks/useModal";
import { useEffect, useState } from "react";
import down_arrow_img from "../../../../Assets/images/down-arro.png"
import { useGetRecommendationTemplatesQuery, useLazyGetRecommendationTemplatesQuery } from "store/services/clients/reports-v2/recommendationTemplates";

const QuestionCustomEditor = ({ question, speechToText = false, fieldName, fieldData, previewMode, clientType, assessmentId, charLimit = 1500 }) => {
    const { show, data, open, close } = useModal();
    // useEffect(() => {
    //     if (!fieldData?.length) {
    //         return;
    //     }


    //     // fieldData.forEach((data, index) => {
    //     //     setFieldValue(`${fieldName}`, {
    //     //         id: data?.id,
    //     //         answers: data?.answers,
    //     //         attachmentData: data?.attachmentData ? JSON.parse(data?.attachmentData) : [],
    //     //     })
    //     // })
    // }, [fieldData, fieldName]);



    return (
        <div>
            <SaveRecommendationTemplatePop
                showPopup={show}
                closePopup={close}
                data={data}
                clientType={clientType}
                assessmentId={assessmentId}
            />
            <div className="mb-4">
                <div className="ck-editor-wrapper">
                    <CustomEditor speechToText={speechToText} limit={charLimit} name={`${fieldName}.answer`} />
                </div>
            </div>
        </div>
    );
};


export default QuestionCustomEditor;